import React from 'react';
import { BaseHint } from 'components/hintTypes';
import { Intent } from 'constants/ui';
const BulkReschedulingApprovedHint = () => (React.createElement(BaseHint, { intent: Intent.WARNING, title: "Rescheduling approved payments will dismiss any completed approvals." }));
export default BulkReschedulingApprovedHint;
